import { render, staticRenderFns } from "./ControlPanel.vue?vue&type=template&id=3b436a2e&scoped=true"
import script from "./ControlPanel.vue?vue&type=script&lang=js"
export * from "./ControlPanel.vue?vue&type=script&lang=js"
import style0 from "./ControlPanel.vue?vue&type=style&index=0&id=3b436a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b436a2e",
  null
  
)

export default component.exports